@if (!expanded() && !minimized()) {
  <rt-icon-button
    #menuTriggerOrigin="rtOverlayOrigin"
    rt-overlay-origin
    [pwTestId]="testIds.menu"
    variant="plain"
    iconName="menu"
    size="small"
    [rtTooltip]="'tlc.tellent_assistant.header.tooltip_menu' | translate"
    rtTooltipPosition="above"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation(); menu.emit()"
  />
}
@if (inThread() || minimized()) {
  <rt-heading variant="subheading" class="title">
    <span class="title-text">{{ title() }}</span>
  </rt-heading>
}
<div class="actions">
  @if (inThread() && !minimized()) {
    <rt-icon-button
      [pwTestId]="testIds.newChat"
      variant="plain"
      iconName="edit-square"
      size="small"
      [rtTooltip]="'tlc.tellent_assistant.header.tooltip_new_chat' | translate"
      rtTooltipPosition="below"
      (mousedown)="$event.stopPropagation()"
      (click)="$event.stopPropagation(); newChat.emit()"
    />
  }
  @if (expanded() && inThread()) {
    <rt-icon-button
      #menuOrigin="rtOverlayOrigin"
      rt-overlay-origin
      [pwTestId]="testIds.more"
      variant="plain"
      iconName="more-vert"
      size="small"
      class="more"
      [active]="menuOpen()"
      (mousedown)="$event.stopPropagation()"
      (click)="$event.stopPropagation(); menuOpen.set(true)"
    />
    <ng-template
      rt-connected-overlay
      [origin]="menuOrigin"
      [open]="menuOpen()"
      [positions]="menuPositions"
      [offsetY]="4"
      [width]="180"
      hasBackdrop
      withOverlayLevel
      (backdropClick)="menuOpen.set(false)"
    >
      <rt-dropdown>
        <rt-dropdown-item
          [pwTestId]="testIds.menuPin"
          (click)="menuOpen.set(false); pinThread.emit()"
        >
          <rt-icon name="pin" prefix />{{ pinLabel() | translate }}
        </rt-dropdown-item>
        <rt-divider />
        <rt-dropdown-item [pwTestId]="testIds.menuRemove" (click)="menuOpen.set(false)">
          <rt-icon name="delete" prefix />{{
            'tlc.tellent_assistant.header.menu_remove' | translate
          }}
        </rt-dropdown-item>
      </rt-dropdown>
    </ng-template>
  }
  @if (windowControls()) {
    <rt-icon-button
      [pwTestId]="testIds.minimize"
      variant="plain"
      [iconName]="minimizeIcon()"
      size="small"
      [rtTooltip]="minimizeTooltip() | translate"
      rtTooltipPosition="below"
      (mousedown)="$event.stopPropagation()"
      (click)="$event.stopPropagation(); toggleMinimize()"
    />
    <rt-icon-button
      [pwTestId]="testIds.modeToggle"
      variant="plain"
      [iconName]="fullscreenIcon()"
      size="small"
      class="mode-toggle"
      [rtTooltip]="fullscreenTooltip() | translate"
      rtTooltipPosition="below"
      (mousedown)="$event.stopPropagation()"
      (click)="$event.stopPropagation(); toggleFullscreen()"
    />
  }
  <rt-icon-button
    [pwTestId]="testIds.close"
    variant="plain"
    iconName="close"
    size="small"
    class="close"
    [rtTooltip]="'tlc.tellent_assistant.header.tooltip_close' | translate"
    rtTooltipPosition="below"
    (mousedown)="$event.stopPropagation()"
    (click)="$event.stopPropagation(); close.emit()"
  />
</div>
